/* eslint-disable no-alert */
export const calculateAge = (date, separator = "/") => {
	if (date) {
		if (separator === "-") {
			const [year, month, day] = date.split("-")
			const birthday = new Date(`${year}/${month}/${day}`)
			const diff = Date.now() - birthday.getTime()

			return new Date(diff).getUTCFullYear() - 1970
		}

		const [day, month, year] = date.split("/")
		const birthday = new Date(`${year}/${month}/${day}`)
		const diff = Date.now() - birthday.getTime()
		return new Date(diff).getUTCFullYear() - 1970
	}

	return 0
}

export const isYearSelected = (date, separator = "/", defaultYear = new Date().getFullYear()) => {
	if (date) {
		if (separator === "-") {
			const [year, month, day] = date.split("-")

			return Number(year) !== Number(defaultYear)
		}

		const [day, month, year] = date.split("/")
		return Number(year) !== Number(defaultYear)
	}

	return false
}
